import React, { ChangeEvent, useEffect, useState } from "react";
import {
  useBenchmarkActions,
  useBenchmarkState,
} from "../../../../../../store/GlobalContext";
import { ChangesPerDay } from "../ChangesPerDay";
import { minGreaterThanMaxError, setNewValue } from "../ChangesPerDayFunctions";

export default function UpgradingPercentagePerDayContainer() {
  const benchmarkState = useBenchmarkState();
  const { updateFilterUpgradingPercentage } = useBenchmarkActions();

  const [min, setMin] = useState<number | null>(null);
  const [max, setMax] = useState<number | null>(null);

  useEffect(() => {
    setMin(benchmarkState.editingFilterState.upgradingPercentage.min);
    setMax(benchmarkState.editingFilterState.upgradingPercentage.max);
  }, [benchmarkState.editingFilterState.upgradingPercentage]);

  const handleBlur = () => {
    if (!minGreaterThanMaxError(min, max))
      updateFilterUpgradingPercentage({ min: min, max: max });
  };

  const handleChange = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    textField: string
  ) => {
    const setFunction = textField === "max" ? setMax : setMin;
    setNewValue(event.target.value, setFunction);
  };

  return (
    <ChangesPerDay
      type="upgradingPercentage"
      min={min}
      max={max}
      minGreaterThanMaxError={minGreaterThanMaxError(min, max)}
      maxValueExceededError={max != null && max > 100}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
}
